/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimpleDataRequestResource } from './SimpleDataRequestResource';
import {
    SimpleDataRequestResourceFromJSON,
    SimpleDataRequestResourceFromJSONTyped,
    SimpleDataRequestResourceToJSON,
    SimpleDataRequestResourceToJSONTyped,
} from './SimpleDataRequestResource';
import type { HistoricMeanSpan } from './HistoricMeanSpan';
import {
    HistoricMeanSpanFromJSON,
    HistoricMeanSpanFromJSONTyped,
    HistoricMeanSpanToJSON,
    HistoricMeanSpanToJSONTyped,
} from './HistoricMeanSpan';

/**
 * 
 * @export
 * @interface OperatorPrognosisMonetaryRequest
 */
export interface OperatorPrognosisMonetaryRequest {
    /**
     * 
     * @type {number}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    timeTo: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    referenceDate?: number;
    /**
     * 
     * @type {Array<SimpleDataRequestResource>}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    resources: Array<SimpleDataRequestResource>;
    /**
     * budget production metric key
     * @type {string}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    budgetProductionMetricKey: string;
    /**
     * optional forecast production metric key
     * @type {string}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    forecastProductionMetricKey?: string;
    /**
     * DFÜ production metric key
     * @type {string}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    dfueProductionMetricKey: string;
    /**
     * EVU production metric key
     * @type {string}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    evuProductionMetricKey: string;
    /**
     * Einsman percent value
     * @type {number}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    einsmanPercent: number;
    /**
     * 
     * @type {HistoricMeanSpan}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    historicMeanSpan?: HistoricMeanSpan;
    /**
     * optional manual value to fill future values of plan commission in ct/kWh
     * @type {number}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    manualCommissionPlan?: number;
    /**
     * optional manual value to fill future values of actual commission in ct/kWh
     * @type {number}
     * @memberof OperatorPrognosisMonetaryRequest
     */
    manualCommissionActual?: number;
}



/**
 * Check if a given object implements the OperatorPrognosisMonetaryRequest interface.
 */
export function instanceOfOperatorPrognosisMonetaryRequest(value: object): value is OperatorPrognosisMonetaryRequest {
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    if (!('resources' in value) || value['resources'] === undefined) return false;
    if (!('budgetProductionMetricKey' in value) || value['budgetProductionMetricKey'] === undefined) return false;
    if (!('dfueProductionMetricKey' in value) || value['dfueProductionMetricKey'] === undefined) return false;
    if (!('evuProductionMetricKey' in value) || value['evuProductionMetricKey'] === undefined) return false;
    if (!('einsmanPercent' in value) || value['einsmanPercent'] === undefined) return false;
    return true;
}

export function OperatorPrognosisMonetaryRequestFromJSON(json: any): OperatorPrognosisMonetaryRequest {
    return OperatorPrognosisMonetaryRequestFromJSONTyped(json, false);
}

export function OperatorPrognosisMonetaryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorPrognosisMonetaryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'referenceDate': json['referenceDate'] == null ? undefined : json['referenceDate'],
        'resources': ((json['resources'] as Array<any>).map(SimpleDataRequestResourceFromJSON)),
        'budgetProductionMetricKey': json['budgetProductionMetricKey'],
        'forecastProductionMetricKey': json['forecastProductionMetricKey'] == null ? undefined : json['forecastProductionMetricKey'],
        'dfueProductionMetricKey': json['dfueProductionMetricKey'],
        'evuProductionMetricKey': json['evuProductionMetricKey'],
        'einsmanPercent': json['einsmanPercent'],
        'historicMeanSpan': json['historicMeanSpan'] == null ? undefined : HistoricMeanSpanFromJSON(json['historicMeanSpan']),
        'manualCommissionPlan': json['manualCommissionPlan'] == null ? undefined : json['manualCommissionPlan'],
        'manualCommissionActual': json['manualCommissionActual'] == null ? undefined : json['manualCommissionActual'],
    };
}

export function OperatorPrognosisMonetaryRequestToJSON(json: any): OperatorPrognosisMonetaryRequest {
    return OperatorPrognosisMonetaryRequestToJSONTyped(json, false);
}

export function OperatorPrognosisMonetaryRequestToJSONTyped(value?: OperatorPrognosisMonetaryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'referenceDate': value['referenceDate'],
        'resources': ((value['resources'] as Array<any>).map(SimpleDataRequestResourceToJSON)),
        'budgetProductionMetricKey': value['budgetProductionMetricKey'],
        'forecastProductionMetricKey': value['forecastProductionMetricKey'],
        'dfueProductionMetricKey': value['dfueProductionMetricKey'],
        'evuProductionMetricKey': value['evuProductionMetricKey'],
        'einsmanPercent': value['einsmanPercent'],
        'historicMeanSpan': HistoricMeanSpanToJSON(value['historicMeanSpan']),
        'manualCommissionPlan': value['manualCommissionPlan'],
        'manualCommissionActual': value['manualCommissionActual'],
    };
}

